module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart",
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('div', {
    staticClass: "main"
  }, [(!_vm.uid || _vm.uid == 'null' || _vm.uid == '') ? _c('div', {
    staticClass: "unlogin"
  }, [_c('div', {
    staticClass: "unlogin-img"
  }), _vm._v(" "), _c('p', [_vm._v("您还没有登录，请登录")]), _vm._v(" "), _c('div', {
    staticClass: "goToLogin_btn",
    on: {
      "click": _vm.toGoLogin
    }
  }, [_vm._v("登录")])]) : _c('div', [(_vm.showPage) ? _c('div', [(_vm.orderList.length > 0) ? _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "list order_list",
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "10"
    }
  }, [_c('ul', _vm._l((_vm.orderList), function(order) {
    return _c('li', [_c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "height": "0.8rem",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "80%"
      }
    }, [_c('div', {
      staticClass: "shopImg",
      style: ({
        backgroundImage: 'url(' + order.supplierUrl + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_c('span', {
      staticClass: "arrow-right ellipse shop_name",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(order.supplierId, order.supplier_name, order)
        }
      }
    }, [_vm._v(_vm._s(order.supplier_name))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(order.create_time))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "20%",
        "text-align": "right",
        "color": "#787878"
      }
    }, [_c('div', {
      staticClass: "order-status"
    }, [_vm._v(_vm._s(order.orderStatusStr))]), _vm._v(" "), (order.aboutOutDinnerDesc) ? _c('div', {
      staticStyle: {
        "font-size": ".2rem",
        "color": "#FEC300"
      }
    }, [_vm._v("\n                    " + _vm._s(order.aboutOutDinnerDesc) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "goods-list",
      on: {
        "click": function($event) {
          return _vm.jumpToOrder(order.orderId, order.orderType)
        }
      }
    }, [_vm._l((order.goodsList), function(item) {
      return _c('div', [_c('span', {
        staticClass: "ellipse",
        staticStyle: {
          "display": "inline-block",
          "width": "80%"
        }
      }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('span', {
        staticClass: "fr",
        staticStyle: {
          "color": "#787878"
        }
      }, [_vm._v("x " + _vm._s(item.goodsNum))])])
    }), _vm._v(" "), (order.omit) ? _c('div', {
      staticClass: "moreList"
    }, [_vm._v("···")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "clearflow",
      staticStyle: {
        "width": "100%",
        "margin": "0.15rem 0 0.2rem 0"
      }
    }, [_c('span', {
      staticClass: "fr pr"
    }, [_c('span', {
      staticStyle: {
        "color": "#787878"
      }
    }, [_vm._v("总计")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("￥" + _vm._s(order.real_pay))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearflow"
    }, [(order.canEstimated == 1 && order.orderType != 4) ? _c('span', {
      staticClass: "btn btn-order btn-yellow fr",
      on: {
        "click": function($event) {
          return _vm.toComment(order.orderId)
        }
      }
    }, [_vm._v("评价")]) : _vm._e(), _vm._v(" "), ((order.order_status == 2002 || order.order_status == 3001 || order.order_status == 9000) && order.orderType != 4) ? _c('span', {
      staticClass: "btn btn-order btn-plain fr",
      on: {
        "click": function($event) {
          return _vm.moreOrder(order.orderId, order.supplierId, order.supplier_name)
        }
      }
    }, [_vm._v("再来一单")]) : _vm._e(), _vm._v(" "), (order.order_status == 1000) ? _c('span', {
      staticClass: "btn btn-order btn-yellow fr",
      on: {
        "click": function($event) {
          return _vm.jumpToOrder(order.orderId, order.orderType)
        }
      }
    }, [_vm._v("去支付")]) : _vm._e(), _vm._v(" "), (order.order_status == 1000 && order.orderType != 4) ? _c('span', {
      staticClass: "btn btn-order btn-plain fr",
      staticStyle: {
        "padding": "0.08rem 0.2rem"
      },
      on: {
        "click": function($event) {
          return _vm.cancelOrder(order.orderId)
        }
      }
    }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (order.orderPickUpInfoBean && order.orderPickUpInfoBean.takeStatus == 0) ? _c('span', {
      staticClass: "btn btn-order btn-yellow fr",
      on: {
        "click": function($event) {
          return _vm.openCabinet(order)
        }
      }
    }, [_vm._v("一键开柜取餐")]) : _vm._e(), _vm._v(" "), (order.reminderButton == 1) ? _c('span', {
      staticClass: "btn btn-order btn-yellow fr",
      on: {
        "click": function($event) {
          return _vm.reminderOrder(order.orderId)
        }
      }
    }, [_vm._v("催单")]) : _vm._e()])])
  }), 0)]) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading",
    staticStyle: {
      "margin-top": "-.16rem"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/loading.gif"),
      "alt": ""
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.noNetwork) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1)]) : _vm._e()])]), _vm._v(" "), (_vm.isShowCabinet) ? _c('div', {
    staticClass: "selfWrap"
  }, [_c('div', {
    staticClass: "self-mask",
    staticStyle: {
      "width": "6.4rem",
      "margin-left": "-3.2rem",
      "margin-top": "-3rem",
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "selfInfo1",
    staticStyle: {
      "padding": ".7rem .4rem .5rem .4rem",
      "margin-bottom": "0",
      "background-color": "transparent"
    }
  }, [_c('div', {
    staticClass: "fz-32"
  }, [_c('img', {
    staticClass: "dingwei",
    attrs: {
      "src": require("../assets/images/icon-dingwei@2x.png")
    }
  }), _vm._v("\n          " + _vm._s(_vm.chooseCabinetItem.orderPickUpInfoBean.deviceName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cell-no",
    staticStyle: {
      "width": "1.8rem"
    }
  }, [_c('div', {
    staticClass: "no",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.chooseCabinetItem.orderPickUpInfoBean.cellNo) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "color": "#797979"
    }
  }, [_vm._v("箱号")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": ".4rem 0"
    }
  }, [_vm._v("请确保在自提柜附近操作开柜，防止餐品丢失。")]), _vm._v(" "), (!_vm.isShowProgress) ? _c('div', {
    staticClass: "btn-open",
    staticStyle: {
      "height": ".84rem",
      "line-height": ".84rem",
      "margin-bottom": ".2rem"
    },
    on: {
      "click": _vm.sureCabinet
    }
  }, [_vm._v("确认开柜\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isShowProgress) ? _c('div', {
    staticClass: "progressbar"
  }, [_c('div', {
    staticClass: "fill"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-cancle",
    on: {
      "click": _vm.cancelCab
    }
  }, [_vm._v("取消开柜")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/no-order.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("还没有产生过订单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/no-net.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("连接不到网络...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-64154cc4","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/OrderList.vue
// module id = 445
// module chunks = 7